// src/app/auth/auth-guard.service.ts
import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import {AuthService} from '../services';
import {Observable} from 'rxjs/Observable';
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(public authService: AuthService, public router: Router) {
  }
  canActivate(): boolean {
    if (!this.authService.isAuthenticated()) {
      //this.router.navigate(['login']);
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/components/app/infrastructure/guards/auth.guard.ts